var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconListUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_list_up",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_24777",
    "data-name": "\\uC0AC\\uAC01\\uD615 24777",
    width: 24,
    height: 24,
    fill: "rgba(255,0,0,0.1)",
    opacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_5",
    "data-name": "\\uC0AC\\uAC01\\uD615 5",
    width: 24,
    height: 24,
    transform: "translate(0 0)",
    fill: "rgba(255,0,0,0.1)",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD328\\uC2A4_37",
    "data-name": "\\uD328\\uC2A4 37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_336",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 336",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8127",
    "data-name": "\\uD328\\uC2A4 8127",
    d: "M53.633,130.7a.6.6,0,0,0-.407.159l-4,3.692a.6.6,0,1,0,.814.882l3.593-3.316,3.593,3.316a.6.6,0,1,0,.814-.882l-4-3.692A.6.6,0,0,0,53.633,130.7Z",
    transform: "translate(-41.133 -120.8)",
    fill: "#484848"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListUp);
export default __webpack_public_path__ + "static/media/icon_list_up.f5f9943e7687b6ae36bbc1faa609cb0d.svg";
export { ForwardRef as ReactComponent };